import axios from 'axios'
import { verificarTokenAutenticacao } from '../../middleware/Token'

const BASEURLGESTTOR = axios.create({
    baseURL: process.env.REACT_APP_API_GESTTOR,
    headers: {
        'Content-Type': 'application/json',
    }

})

export const BASEAPIGESTTORAUTH = axios.create ({
    baseURL: process.env.REACT_APP_API_GESTTOR,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const BASEURLGESTTORFORMDATA = axios.create ({
    baseURL: process.env.REACT_APP_API_GESTTOR,
    headers: {
        'Content-Type': 'multipart/form-data',
    }

})

BASEURLGESTTORFORMDATA.interceptors.request.use (async config => {
    const token = verificarTokenAutenticacao ()

    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }

    return config
})


BASEURLGESTTOR.interceptors.request.use(async config => {
    const token = verificarTokenAutenticacao()

    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }

    return config
})



export default BASEURLGESTTOR